import React, { useEffect, useState } from "react";
import CustomerInfo from "./Customerinfo.style";
import { LinkAnchor, _getAllProduct, addToCartMethod } from "@Components/Common/CommonMethods";
import FirstSection from "./Components/FirstSection";
import InforSecondSection from "./Components/InfoSecondSection";
import PotentialSection from "./Components/PotentialSection";
import FourthSection from "./Components/FourthSection";
import Accordioninfo from "./Components/AccordianInfo";
import HippaIconSection from "@Components/Common/HippaIconSection";
import DialogCustomerinfo from "./Components/DialogCustomerinfo";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { LeftRightDesginIcon } from "@Components/Common/CommonMethods";
import ThreeContainerSection from "./Components/ThreeContainerSection";
import { useRef } from "react";
import Link from "next/link";
import CommonDialogPopup from "./Components/CommonDialogPopup";
const customer_info = (props) => {
   const [snpKitPopup, setSnpKitPopup] = useState(false);
   const [cartNotify, setCartNotify] = useState('');
   const [productData, setProductData] = useState();
   const [formulaData, setFormulaData] = useState();
   const [ancestryFormulaData, setAncestryFormulaData] = useState();

   const [avaibleproducts, setAvaibleProducts] = useState();
   const [errorMsg, setErrorMsg] = useState('');
   const [openKitAncestry, setOpenKitAncestry] = useState(false);

   const router = useRouter();

   useEffect(() => {
      const category = [2, 3];
      _getAllProduct(false, category).then((res) => {
         let OBJECT = res?.find(obj => obj?.category_id === 3);
         let OBJECT_Formula = res?.find(obj => obj?.sku === "KIT-SURVEY");
         let OBJECT_ANCESTRY_Formula = res?.find(obj => obj?.sku === "KIT-SURVEY-ANCESTRY");
         setProductData(OBJECT)
         setFormulaData(OBJECT_Formula)
         setAncestryFormulaData(OBJECT_ANCESTRY_Formula)
      })
   }, []);

   const Avaible_products = props?.cartdata?.products?.filter((item) => item?.product?.sku === "KIT-SURVEY");
   const Ansentry_avaible_products = props?.cartdata?.products?.filter((item) => item?.product?.sku === "KIT-SURVEY-ANCESTRY");


   function handleAddKitProduct() {
      Cookies.set('kitProductId', productData?.id, new Date(new Date().getTime() + 15 * 60 * 1000));
      const kit_Product = Cookies.get("kitProductId")
      props?.setInnerLoader(true)
      if (kit_Product) {
         addToCartMethod(
            {
               id: productData?.id,
               quantity: 1,
               is_autoship: false,
            },
            props?.setshowminicart,
            setCartNotify,
            props?.cartdata?.products,
            props?.setCartData,
            false,
            setErrorMsg,
         )
         router?.push("/us/cart/viewCart/")
         props?.setInnerLoader(false)

      }
   };

   function FormulahandleAddKitProduct() {
      setOpenKitAncestry(false);
      Cookies.remove('AncestryFormulakitProductId');
      Cookies.set('FormulakitProductId', formulaData?.id, new Date(new Date().getTime() + 15 * 60 * 1000));
      const kit_Product = Cookies.get("FormulakitProductId")
      props?.setInnerLoader(true);
      if (kit_Product) {
         if (Avaible_products?.length > 0) {
            addToCartMethod(
               {
                  id: formulaData?.id,
                  quantity: 0,
                  is_autoship: false,
               },
               props?.setshowminicart,
               setCartNotify,
               props?.cartdata?.products,
               props?.setCartData,
               false,
               setErrorMsg,
            )

         } else {
            addToCartMethod(
               {
                  id: formulaData?.id,
                  quantity: 1,
                  is_autoship: false,
               },
               props?.setshowminicart,
               setCartNotify,
               props?.cartdata?.products,
               props?.setCartData,
               false,
               setErrorMsg,
            )
            router?.push("/us/cart/viewCart/")
         }
         props?.setInnerLoader(false)


      }
   };

   function FormulahandleAddKitProductAncestry() {
      setOpenKitAncestry(false);
      Cookies.remove('FormulakitProductId')
      Cookies.set('AncestryFormulakitProductId', ancestryFormulaData?.id, new Date(new Date().getTime() + 15 * 60 * 1000));
      const kit_Product = Cookies.get("AncestryFormulakitProductId")
      localStorage.setItem('ancestryKey', true)
      props?.setInnerLoader(true);
      if (kit_Product) {
         if (Ansentry_avaible_products?.length > 0) {
            addToCartMethod(
               {
                  id: ancestryFormulaData?.id,
                  quantity: 0,
                  is_autoship: false,
               },
               props?.setshowminicart,
               setCartNotify,
               props?.cartdata?.products,
               props?.setCartData,
               false,
               setErrorMsg,
            )

         } else {
            addToCartMethod(
               {
                  id: ancestryFormulaData?.id,
                  quantity: 1,
                  is_autoship: false,
               },
               props?.setshowminicart,
               setCartNotify,
               props?.cartdata?.products,
               props?.setCartData,
               false,
               setErrorMsg,
            )
            router?.push("/us/cart/viewCart/")
         }
         props?.setInnerLoader(false)


      }
   };
   const ref = useRef(null);

   const scrollhandleClick = () => {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: "center" });
   };

   const items = [
      {
         title: "Heart Health",
         content: <>
            <p>Your heart carries the huge responsibility of transporting oxygen-rich blood to every part of your body. In addition, a well-functioning cardiovascular system self-maintains, promotes, and supports overall health.</p> <br />
            <p>Your personalized <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> provides tailor-made supplementation to <strong>ensure your body receives the optimum nutrients required for supporting healthy heart function.</strong> </p> <br />
            <p>Whether it’s managing fat utilization, promoting vitamin uptake, or maintaining healthy cholesterol levels, <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> supports your cardiovascular system in self-maintaining and promoting overall health.</p>
         </>
      },
      {
         title: "Cognitive and Brain Function",
         content: <>
            <p>84% of all human genes are expressed in the brain. These genes influence how the brain develops and works. They also control how we think, feel, move, and behave.</p> <br />
            <p>Your <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> supplement addresses your unique genetic needs, providing essential nutrients that <strong>support YOUR optimal brain function, stress resilience, and healthy neuroinflammatory responses</strong> – you can unlock the full potential of your cognitive abilities.</p>
         </>
      },
      {
         title: "Energy",
         content: <>
            <p>Our cells run off a molecule called ATP (Adenosine Triphosphate). It is an essential fuel source for thousands of cellular functions. ATP is vital for cellular health across all systems of your body.</p> <br />
            <strong>Supporting your body's natural ATP production at optimal levels requires a specific recipe of essential nutrients and compounds.</strong> <br /> <br />
            <p>By looking closely at genes that protect your cells from oxidation and encourage proper methylation, as well as your ability to receive various nutrients, we formulate your <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> supplement to support optimal ATP production, to help you feel physically and emotionally alive.</p>
         </>
      },
      {
         title: "Gut & Microbiome",
         content: <>
            <p>Your microbiome requires a fine-tuning of specific genes to maximize your intestinal and digestive health.</p> <br />
            <p>When this critical system is out of balance, it can seriously impact the body – leading to excessive body fat storage and dietary cravings, which then continue to negatively impact your microbiome when out of alignment.</p> <br />
            <p>That’s why we formulate <strong><Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> to fine-tune your genetic expression for optimal gut health,</strong> supporting a balanced microbiome and influencing everything from mood and neurotransmitter production to healthy detoxification processes.</p>
         </>
      },
      {
         title: "Healthy Immune Response ",
         content: <>
            <p>The immune system is a network of organs, cells, and proteins that defend the body against infection. It consists of many processes that must be successfully orchestrated, like the production of white blood cells and antibodies, and functional lymphatic flow.</p> <br />
            <p>Because of the immune system’s complexity, it’s critical to support any of the associated genes that may be functioning less than optimally so that nutritional support can be optimized for genetic expression impacting overall health.</p> <br />
            <p>Which is why we craft your <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> supplement to <strong>support the genetic expressions that contribute to an immune system that is calibrated to activate on time, respond proportionately, and stop when necessary.</strong></p>
         </>
      },
      {
         title: "Healthy Inflammatory Response",
         content: <>
            <p>If you have a genetic vulnerability that makes you more susceptible to inflammation, your body needs additional support when facing injuries, irritants or allergens.</p> <br />
            <strong>
               A healthy inflammatory response is also necessary for healthy weight management, mental clarity, sound sleep, and healthy immune function...
            </strong> <br /><br />
            <p>Your <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> will assist in maintaining a balanced inflammatory response at the genetic level, contributing to overall wellness and vitality.</p>
         </>
      },
      {
         title: "Methylation",
         content: <>
            <p>Methylation is a process that happens countless times each second in critical systems throughout the human body. In this process, small molecules called “methyl groups” are added to pieces of DNA, nutrients, and proteins, acting like a switch to turn the gene “on” or “off.”</p> <br />
            <p>Proper methylation is a critical component of overall health as it has compounding effects on numerous other genes and their regulation. The quality of this process declines with age, but by supporting optimal methylation, we can provide improved energy, sleep, mood, motivation, digestion, and much more. </p><br />
            <p>That’s why we formulate your <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> supplement to provide you with the essential nutrients your body requires for optimal gene regulation, <strong>contributing to improved energy, mood, digestion, and overall well-being.</strong></p>
         </>
      },
      {
         title: "Mood",
         content: <>
            <p>We may not consider mood to be relevant when looking at the genetic pathways that indicate our overall health, but the truth is that mood is linked to several health factors and can be an indicator of nutritional absorption and overall health.</p> <br />
            <p>This in turn affects how we feel, behave, and interact with others.</p><br />
            <p>That’s why we tailor your <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> formula to the genes associated with vitamin receptors, healthy inflammatory response, and methylation factors – ensuring you <strong>receive the right nutrients to support mood-regulating pathways</strong> to help you maintain a positive and balanced state of mind.</p>
         </>
      },
      {
         title: "Detoxification",
         content: <>
            <p>Detoxification might not be the first thing that comes to mind when considering the genetic pathways that influence our overall health, but the reality is that our body's ability to process and eliminate pollutants is crucial to maintaining optimal health. </p><br />
            <p>Pollutants can come from external sources such as our food, water, air, cosmetics, and cleaning supplies, or they can be internally produced as byproducts of our body's metabolic processes.</p><br />
            <p>Without effective detoxification, these toxins can accumulate in our bodies, affecting a wide range of physiological functions.</p><br />
            <p>Your <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> supplement <strong>aids your body’s natural detoxification processes, ensuring effective elimination of toxins</strong> and supporting your overall health and vitality.</p>
         </>
      },
      {
         title: "Healthy Body Mass Index (BMI)",
         content: <>
            <p>Supporting a healthy ratio of body fat to your height and weight optimizes the functionality of every system in your body and can impact numerous other vulnerabilities.</p><br />
            <p>Using 19 specific SNPs to determine how efficiently your body is able to digest, metabolize, and absorb certain nutrients and micronutrients, we calibrate your CODE Complex™ Supplement to your nutritional needs. </p><br />
            <p>This process provides <strong>a targeted nutritional recipe to help you upregulate the healthiest expression of SNPs associated with BMI</strong>  and support your most optimal health.</p>
         </>
      },
   ]

   return (
      <>
         <div className="main_background_customer_info">
            <LeftRightDesginIcon>

               <CustomerInfo>
                  <div className="container customerinfo-main-section">
                     <FirstSection scrollhandleClick={scrollhandleClick} />
                     <div className="data-required-section">
                        <InforSecondSection snpKitPopup={snpKitPopup} setSnpKitPopup={setSnpKitPopup} handleAddKitProduct={handleAddKitProduct} FormulahandleAddKitProduct={FormulahandleAddKitProduct}
                           scrollhandleClick={scrollhandleClick} Avaible_products={Avaible_products}
                           FormulahandleAddKitProductAncestry={FormulahandleAddKitProductAncestry} setOpenKitAncestry={setOpenKitAncestry} />

                        <PotentialSection snpKitPopup={snpKitPopup} setSnpKitPopup={setSnpKitPopup} scrollhandleClick={scrollhandleClick} />

                        <FourthSection setSnpKitPopup={setSnpKitPopup} handleAddKitProduct={handleAddKitProduct}
                           FormulahandleAddKitProduct={FormulahandleAddKitProduct} Avaible_products={Avaible_products}
                           FormulahandleAddKitProductAncestry={FormulahandleAddKitProductAncestry} setOpenKitAncestry={setOpenKitAncestry} />
                     </div>

                  </div>
                  <div className="nutrition-support-section" id="nutrition-section" ref={ref}>
                     <div className="container customerinfo-main-section supportn-section">
                        <div className="supportn-heading">
                           <h2 className="code-complex-heading">CODE Complex™</h2>
                           <h2>Personalized, Comprehensive Nutritional Support</h2>
                        </div>
                        <div className="main-support-section">
                           <div className="left-product-content">
                              <h3>Science-Driven, DNA-Based Precision Nutrition for Whole Body Health</h3>
                              <ul>
                                 <li>Made to order based on your genetics</li>
                                 <li>High-potency, bioactive ingredients</li>
                                 <li>Prebiotics + digestive enzymes</li>
                                 <li>Whole foods + adaptogens</li>
                                 <li>Non-GMO, gluten-free</li>
                                 <li>3rd party tested</li>
                                 <li>Compounded in the USA</li>
                              </ul>
                           </div>
                           <div className="right-image-section">
                              <figure>
                                 <img src="/images/code_comple.png"></img>
                              </figure>
                              <ul>
                                 <li>
                                    <span>
                                       <img src="/images/non_gmo_icon.png" alt="Image" />
                                    </span>
                                    Non-GMO
                                 </li>
                                 <li>
                                    <span>
                                       <img src="/images/daily_free.png" alt="Image" />
                                    </span>
                                    Dairy Free
                                 </li>
                                 <li>
                                    <span>
                                       <img src="/images/soy_free.png" alt="Image" />
                                    </span>
                                    Soy Free
                                 </li>
                                 <li>
                                    <span>
                                       <img src="/images/gluten_free_icon.png" alt="Image" />
                                    </span>
                                    Gluten Free
                                 </li>
                                 <li>
                                    <span>
                                       <img src="/images/nut_free_icon.png" alt="Image" />
                                    </span>
                                    Nut Free
                                 </li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="container customerinfo-main-section accordian-section-main">
                     <div className="accordian-section">
                        <p>Here's a look at the key health areas <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> is designed to impact. Click the drop-down arrow next to each area to discover the many ways your personalized supplement can support your overall wellness and vitality:</p>
                        <Accordioninfo items={items} />
                     </div>

                     <h3 style={{ fontStyle: "italic" }}>Do you have the data required for us to formulate? </h3>

                     <div className="find-out-button-section">

                        <a className="find-out-button" onClick={() => setSnpKitPopup(true)}>Click here to find out</a>

                     </div>
                     <h2 className="fast-track-to-heading">Fast-Track to Optimal Living</h2>
                     <p>
                        Time is of the essence when it comes to your well-being.
                     </p>
                     <p>
                        Every day you go <em>without</em> giving your unique body the nutritional support it needs is another day you risk slipping further from the state of vitality that is your birthright.
                     </p>
                     <p>
                        Your tailored <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> supplement offers the foundational essential vitamins, minerals, and micronutrients your body is longing for - to return your health to a place of balance...
                     </p>
                     <p>
                        And elevate your life to a new potential.
                     </p>
                     <p>
                        By pairing this tailored knowledge with our <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> supplement, you're not just addressing health concerns…
                     </p>
                     <h4>You’re paving the way for an optimal life.</h4>
                     <p>
                        Simply click the button for your DNA Test Provider below to get started.
                     </p>


                     {/* <div className="main-three-container-section">
                  <div className="andme-first-section box-content-section">
                     <h2>23&Me</h2>

                     <p>Simple easy-to-follow instructions to turn cryptic DNA data into a personalized nutritional recipe unlocking your full health potential. </p>

                     <div className="get-nutritional-code">

                        <a className="get-nutritional-code-button" onClick={handleAddKitProduct}>Press to Get Your Nutritional Code Now</a>

                     </div>

                  </div>
                  <div className="andme-second-section box-content-section disabled">
                     <h2>Ancestry</h2>

                     <p>Simple easy-to-follow instructions to turn cryptic DNA data into a personalized nutritional recipe unlocking your full health potential.</p>
                     <div className="get-nutritional-code">

                        <LinkAnchor className="get-nutritional-code-button" href="#">Press to Get Your Nutritional Code Now</LinkAnchor>

                     </div>
                     <div className="coming-soon-text">
                        <h4>Coming Soon</h4>
                     </div>
                  </div>
                  <div className="andme-third-section box-content-section disabled">
                     <h2>Other Genetic Test Results</h2>

                     <p>Simple easy-to-follow instructions to turn cryptic DNA data into a personalized nutritional recipe unlocking your full health potential.</p>

                     <div className="get-nutritional-code">

                        <LinkAnchor className="get-nutritional-code-button" href="#">Press to Get Your Nutritional Code Now</LinkAnchor>

                     </div>
                     <div className="coming-soon-text">
                        <h4>Coming Soon</h4>
                     </div>
                  </div>
               </div> */}

                     <ThreeContainerSection setSnpKitPopup={setSnpKitPopup} handleAddKitProduct={handleAddKitProduct}
                        FormulahandleAddKitProduct={FormulahandleAddKitProduct} Avaible_products={Avaible_products}
                        FormulahandleAddKitProductAncestry={FormulahandleAddKitProductAncestry} setOpenKitAncestry={setOpenKitAncestry} />
                  </div>
                  <div className='text_section'>
                     <div className="container">
                        <div className="advanced-privacy-content">
                           <div className='d-flex'>
                              <div className='content-privacy-protection'>
                                 <p>SNiP Nutrigenomics is committed to your privacy protection. </p>
                                 <p>
                                    We do not store or sell your DNA data to third parties, including employers, health insurance companies, or other entities.
                                 </p>
                              </div>
                              <div className='text-privacy-protection'>
                                 <h2 className="advanced-privacy">Advanced Privacy Protection</h2>
                              </div>
                           </div>
                           <p>
                              {/* the purposes of generating your Summary DNA Health Report, Supplement Fact
                        Panel (SFP), and for the DNA-informed customization of your personalized nutritional
                        supplement. */}

                              {/* Your DNA is collected solely for the purposes of generating your DNA report (s) and for the 
                     DNA-informed customization of your personalized nutritional supplement. */}

                              Your DNA data is collected solely for the purposes of generating your Summary DNA report and
                              Supplement Facts panel (SFP) and for the DNA-informed customization of your personalized nutritional supplement.
                           </p>
                        </div>
                     </div>
                  </div>
                  <HippaIconSection />
                  <DialogCustomerinfo snpKitPopup={snpKitPopup} setSnpKitPopup={setSnpKitPopup} handleAddKitProduct={handleAddKitProduct} />
                  <CommonDialogPopup setOpenKitAncestry={setOpenKitAncestry} openKitAncestry={openKitAncestry}
                     FormulahandleAddKitProduct={FormulahandleAddKitProduct} FormulahandleAddKitProductAncestry={FormulahandleAddKitProductAncestry} props={props} />
               </CustomerInfo>
            </LeftRightDesginIcon>
         </div>
      </>
   )
}

export default customer_info;